function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _spinnerConfig = /*#__PURE__*/new WeakMap();
var _spinnerTimeout = /*#__PURE__*/new WeakMap();
var _globalSpinner = /*#__PURE__*/new WeakMap();
var _spinnerClass = /*#__PURE__*/new WeakMap();
var _GlobalSpinner_brand = /*#__PURE__*/new WeakSet();
export var GlobalSpinner = /*#__PURE__*/function () {
  function GlobalSpinner(spinnerConfig) {
    _classCallCheck(this, GlobalSpinner);
    _classPrivateMethodInitSpec(this, _GlobalSpinner_brand);
    _classPrivateFieldInitSpec(this, _spinnerConfig, void 0);
    _classPrivateFieldInitSpec(this, _spinnerTimeout, void 0);
    _classPrivateFieldInitSpec(this, _globalSpinner, void 0);
    _classPrivateFieldInitSpec(this, _spinnerClass, 'ilcSpinnerWrapper');
    var defaultSpinnerConfig = {
      enabled: true,
      customHTML: '',
      showAfter: 300,
      minimumVisible: 500
    };
    _classPrivateFieldSet(_spinnerConfig, this, Object.assign({}, defaultSpinnerConfig, spinnerConfig));
  }

  /**
   * @method start
   * @return void
   */
  return _createClass(GlobalSpinner, [{
    key: "start",
    value: function start(_ref) {
      var _this = this;
      var onBeforeStart = _ref.onBeforeStart;
      console.log('start .... ');
      _classPrivateFieldSet(_spinnerTimeout, this, setTimeout(function () {
        onBeforeStart && onBeforeStart({
          minimumVisibleTime: _classPrivateFieldGet(_spinnerConfig, _this).minimumVisible
        });
        if (!_classPrivateFieldGet(_spinnerConfig, _this).customHTML) {
          _assertClassBrand(_GlobalSpinner_brand, _this, _runDefaultSpinner).call(_this);
        } else {
          _assertClassBrand(_GlobalSpinner_brand, _this, _runCustomSpinner).call(_this);
        }
      }, _classPrivateFieldGet(_spinnerConfig, this).showAfter));
    }
  }, {
    key: "stop",
    value: function stop() {
      if (_classPrivateFieldGet(_globalSpinner, this)) {
        _classPrivateFieldGet(_globalSpinner, this).remove();
        _classPrivateFieldSet(_globalSpinner, this, null);
      }
      clearTimeout(_classPrivateFieldGet(_spinnerTimeout, this));
      _classPrivateFieldSet(_spinnerTimeout, this, null);
    }

    /**
     * @method isEnabled
     * @returns {boolean}
     */
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return !!_classPrivateFieldGet(_spinnerConfig, this).enabled;
    }

    /**
     * @method isInProgress
     * @returns {boolean}
     */
  }, {
    key: "isInProgress",
    value: function isInProgress() {
      return !!_classPrivateFieldGet(_spinnerTimeout, this);
    }
  }]);
}();
function _runDefaultSpinner() {
  _classPrivateFieldSet(_globalSpinner, this, document.createElement('dialog'));
  _classPrivateFieldGet(_globalSpinner, this).setAttribute('class', _classPrivateFieldGet(_spinnerClass, this));
  _classPrivateFieldGet(_globalSpinner, this).innerHTML = 'loading....';
  document.body.appendChild(_classPrivateFieldGet(_globalSpinner, this));
  _classPrivateFieldGet(_globalSpinner, this).showModal();
}
function _runCustomSpinner() {
  _classPrivateFieldSet(_globalSpinner, this, document.createElement('div'));
  _classPrivateFieldGet(_globalSpinner, this).classList.add(_classPrivateFieldGet(_spinnerClass, this));
  _classPrivateFieldGet(_globalSpinner, this).innerHTML = _classPrivateFieldGet(_spinnerConfig, this).customHTML;
  document.body.appendChild(_classPrivateFieldGet(_globalSpinner, this));

  // run script tags
  _classPrivateFieldGet(_globalSpinner, this).querySelectorAll('script').forEach(function (oldScript) {
    var newScript = document.createElement('script');
    newScript.innerHTML = oldScript.innerHTML;
    oldScript.parentNode.insertBefore(newScript, oldScript);
    oldScript.remove();
  });
}